// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Comfortaa/Comfortaa-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Comfortaa:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Poppins", sans-serif;
}

p {
  margin-bottom: 0;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

:root {
  /* Primary Palette */
  --color-primary: #123164;
  --background: #e5e5e5;
  --backgroundDashboard: #f7f9fb;
  --negative: #ea0000;

  /* Grey Scale Palette */
  --white: #ffffff;
  --grey-0: #d7d7d7;
  --grey-1: #a0a0a0;
  --grey-2: #3c3c43;

  --hover: #f7f9fb;

  /* Typography */
  --title-1: 1.5rem;
  --title-2: 0.9375rem;
  --content: 0.875rem;
  --content-2: 0.8125rem;
  --button: 1.125rem;
  --button-2: 0.9375rem;

  /* Cart */
  --amount: 0.625rem;
}

@font-face {
  font-family: Popins-regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: Popins-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: Popins-SemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: Comforta-Regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.textPrimaryLanding {
  margin-top: 2.125rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 2.5rem;

  font-family: Popins-regular;
  color: #123164;
}

.textPrimaryLabelInput {
  font-family: Popins-regular;
  color: black;
  font-weight: 400;
  font-size: 0.875rem;
}

.textPrimaryInput {
  font-family: Popins-regular;
  font-weight: 500;
  font-size: 0.975rem;
  padding: 0 15px;
  color: #5c5b5b;
}

.textErrorInput {
  color: red;
  font-family: Popins-regular;
  position: absolute;
  top: 87px;
  font-size: 0.975rem;
}

.textPrimaryButton {
  color: white;
  font-family: Popins-regular;
  font-weight: 400;
  font-size: 16px;
}

.textForgotPassword {
  color: var(--color-primary);
  font-family: Popins-regular;
}

.textPrimaryForgotPassword {
  margin-top: 2.125rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.0625rem;

  font-family: Popins-regular;
  color: var(--color-primary);
}

.textDescriptionForgotPassword {
  font-family: Popins-regular;
  font-weight: 400;
  font-size: 15px;
  color: var(--black);
  margin-bottom: 2.125rem;
}

.textPrimarySendMail {
  margin-top: 2.125rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.0625rem;
  text-align: center;

  font-family: Popins-regular;
  color: var(--color-primary);
}

.textDescriptionSendMail {
  font-family: Popins-regular;
  font-weight: 400;
  font-size: 15px;
  color: var(--black);
  text-align: center;
}

.textPrimaryResetPassword {
  margin-top: 2.125rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.0625rem;

  font-family: Popins-regular;
  color: var(--color-primary);
}

.textPrimaryRegister {
  margin-top: 2.125rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.0625rem;

  font-family: Popins-regular;
  color: var(--color-primary);
}

.textDescriptionResetPassword {
  font-family: Popins-regular;
  font-weight: 400;
  font-size: 15px;
  color: var(--black);
  margin-bottom: 1.6875rem;
}

.textPrimaryLabelInput {
  font-family: Popins-regular;
  color: black;
  font-weight: 400;
  font-size: 0.875rem;
}

.textLabelInputSelectFilterManager {
  font-family: Popins-regular;
  color: black;
  font-weight: 400;
  font-size: 0.875rem;
  margin-bottom: 14px;
}

.textTitleTermsRegister {
  font-family: Popins-regular;
  color: black;
  font-weight: 600;
  font-size: 0.875rem;
}

.textDescriptionTermsRegister {
  font-family: Popins-regular;
  color: black;
  font-weight: 500;
  font-size: 0.8125rem;
}

.textTermsModalRegister {
  font-family: Popins-regular;
  color: var(--color-primary);
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
}

.textFooterRegisterTitle {
  font-family: Popins-regular;
  color: var(--grey-2);
  font-weight: 500;
  font-size: 0.9375rem;
}

.textFooterRegisterContent {
  font-family: Popins-regular;
  color: var(--color-primary);
  font-weight: 500;
  font-size: 0.9375rem;
}

.textCheckedSidebar {
  font-family: Popins-regular;
  color: var(--white);
  font-weight: 500;
  font-size: 15px;
  margin-bottom: 0;
}

.textNotCheckedSidebar {
  font-family: Popins-regular;
  color: var(--color-primary);
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 0;
}

.textTitleCardQuotation {
  font-family: Popins-regular;
  font-weight: 600;
  font-size: 16px;
}

.textDescriptionCardQuotation {
  font-family: Popins-regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.textTitleTypeDispatch {
  font-family: Popins-regular;
  color: #000000;
  font-weight: 600;
  font-size: 17px;
}

.textDescriptionTypeDispatch {
  font-family: Popins-regular;
  color: #000000;
  font-weight: 400;
  font-size: 14px;
}

.textPrimaryHeaderDashboard {
  font-family: Popins-regular;
  font-weight: 600;
  font-size: 30px;
  color: #062f67;
}

.textUploadImg {
  font-family: Popins-regular;
  color: #000000;
  font-weight: 500;
  font-size: 16px;
}

.textAddNewRoute {
  font-family: Popins-regular;
  font-weight: 600;
  font-size: 15px;
  color: #062f67;
}

.textRemoveNewRoute {
  font-family: Popins-regular;
  font-weight: 600;
  font-size: 15px;
  color: #ea0000;
}

.textTitleSummary {
  font-family: Popins-regular;
  font-weight: 600;
  font-size: 15px;
  color: #6a6a6a;
}

.textPrimaryLoginAdm {
  margin-top: 2.125rem;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 2.5rem;

  font-family: Popins-regular;
  color: #123164;
}

.textTitleShippingCard {
  font-family: Popins-regular;
  font-size: 0.875remx;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.textTypeShippingCard {
  font-family: Popins-regular;
  font-size: 14px;
  font-weight: 500;
  color: #808080;
}

.textTypeValueShippingCard {
  font-family: Popins-regular;
  font-size: 0.875rem;
  font-weight: 500;
  color: #000000;
}

.textTypeValueShippingCardPoints {
  font-family: Popins-regular;
  font-size: 0.875rem;
  font-weight: 500;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: "20px";
  cursor: pointer;
}

.textModalTitleOption {
  font-family: Popins-regular;
  font-size: 17px;
  font-weight: 600;
  color: #000000;
}

.textModalContentOption {
  font-family: Popins-regular;
  font-size: 17px;
  font-weight: 600;
  color: #ea0000;
}

.textNameTableListUser {
  font-family: Popins-Medium;
  color: #6a6a6a;
  font-size: 0.87rem;
  text-align: center;
  width: 170px;
  position: relative;
  top: -6px;
}

.textNameTableListUserTwo {
  font-family: Popins-Medium;
  color: #6a6a6a;
  font-size: 0.87rem;
  text-align: center;
  width: 170px;
}

.textPrimaryModalFilterManager {
  font-family: Popins-Medium;
  font-size: 1.125rem;
  margin-left: 18px;
}

.textModalTableListUserEditPrimary {
  font-family: Popins-Medium;
  color: #030303;
  font-size: 1.12rem;
}

.textUpAddIcon {
  font-family: Popins-Medium;
  color: var(--color-primary);
  font-weight: 500;
  font-size: 20px;
  font-weight: 500;
}

.textAddBlock {
  font-family: Popins-Medium;
  color: var(--color-primary);
  font-weight: 500;
  font-size: 16px;
  font-weight: 500;
}

.textNameTableListManager {
  font-family: Popins-Regular;
  color: #000000;
  font-weight: 500;
  font-size: 12px;
  transform: translateY(2px);
}

.textModalTableListUserEditSecondary {
  font-family: Popins-Medium;
  color: #ea0000;
  font-weight: 500;
  font-size: 1.12rem;
}

.modal-filter-table-list-user-edit {
  width: 24.414vw;
  max-width: 24.414vw;
  border-radius: 20px;
}

.modal-filter-table-list-user {
  width: 74.414vw;
  max-width: 46vw;
}

.errorMessage {
  font-family: Popins-regular;
  color: red;
  font-size: 0.9rem;
  position: absolute;
  top: 84px;
  left: 2px;
}

.textBtnFilterManagerModal {
  font-family: Popins-Medium;
  font-size: 0.938rem;
  color: white;
}

.textConfirmationRemove {
  font-family: Popins-regular;
  font-size: 1.12rem;
  text-align: center;
  margin-top: 1.37rem;
}

.textBtnRemove {
  font-family: Popins-Medium;
  color: #ea0000;
  font-size: 0.93rem;
}

.textPrimaryModalFilterManager {
  font-family: Popins-Medium;
  font-size: 1.125rem;
  margin-left: 18px;
}

.textBtnFilterManager {
  color: white;
  font-family: Popins-Medium;
  font-weight: 500;
  font-size: 15px;
}

.textTitleCardBlackList {
  color: #101828;
  font-family: Popins-Medium;
  font-weight: 500;
  font-size: 14px;
}

.textTypeCardBlackList {
  color: #808080;
  font-family: Popins-Medium;
  font-weight: 500;
  font-size: 14px;
}

.textContentCardBlackList {
  color: #1a1a1a;
  font-family: Popins-Medium;
  font-weight: 500;
  font-size: 14px;
  max-width: 232px;
  text-align: end;
}

.textAddRouteCard {
  font-family: Popins-Medium;
  color: var(--color-primary);
  font-size: 0.93rem;
}

.textRemoveRouteCard {
  font-family: Popins-Medium;
  color: var(--negative);
  font-size: 0.93rem;
}

.textTitleModalQuotation {
  font-family: Popins-Medium;
  color: var(--color-primary);
  font-size: 1.3125rem;
  text-align: center;
}

.textDescriptionModalQuotation {
  font-family: Popins-Regular;
  color: #000;
  font-size: 0.875rem;
  line-height: 20px;
  text-align: center;
}

.textTitleFooterLogin {
  font-size: 0.9375rem;
  font-family: Popins-Medium;
  font-weight: 500;
  color: #3c3c4399;
}

.textContentFooterLogin {
  font-size: 0.9375rem;
  font-family: Popins-Medium;
  color: var(--color-primary);
  font-weight: 500;
  cursor: pointer;
}

/* PDF */

.containerPdf {
  margin: 50px 40px;
  border: 1.5px solid #4176cd;
}

.containerBoxLogo {
  padding: 20px 40px;
}

.headerTitle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.proposal {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}

.contentTitle {
  background-color: #4176cd;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.boxContentTitle {
  display: flex;
  align-items: center;
  gap: 38px;
}

.boxContentTitle p {
  font-size: 10px;
}

.textTitleContent {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.contentValue {
  margin-left: 10px;
}

.contentValueBox {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.contentBoxValueAddressee {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  width: 49%;
}

.beam {
  min-height: 23px;
  max-width: 2px;
  background-color: #4176cd80;
  position: absolute;
  top: 19px;
  left: 56px;
}

.contentBoxValueAddressee div {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.translateAddress {
  transform: translateY(10px);
}

.cardTitleAddressee {
  font-size: 11px;
  font-weight: 400;
  width: 54%;
}

.emailBoxAddressee {
  transform: translateY(-20px);
}

.cardContetAddressee {
  font-size: 11px;
  font-weight: 600;
  width: 100%;
  background-color: #d7d7d7;
  padding-left: 10px;
}

.containerCargoData {
  display: flex;
  align-items: center;
}

.contentTitleCargoData {
  background-color: #4176cd;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  font-size: 14px;
}

.table-container {
  width: 100%;
}

.headerTable {
  border-collapse: collapse;
  width: 100%;
}

.thTable-left {
  font-weight: 600;
  font-size: 10px;
  text-align: start;
  border: 1.5px solid #4176cd;
  padding-left: 10px;
  width: 150px;
}

.contentBoxValueCargoData {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 5px;
  position: relative;
  width: 50%;
}

.contentBoxValueCargoData div {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 300px;
}

.cardTitleCargoData {
  font-size: 14px;
  font-weight: 400;
}

.cardContetCargoData {
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  background-color: #d7d7d7;
  padding-left: 10px;
}

.cardContetCargoDataNotColor {
  font-size: 14px;
  font-weight: 500;
}

.cardContetCargoDataYesColor {
  font-size: 14px;
  font-weight: 500;
  background-color: #f924244f;
  padding: 0 20px;
}

.thTable {
  font-weight: 600;
  font-size: 13px;
  text-align: center;
  border: 1.5px solid #4176cd;
}

.tdTable {
  font-weight: 400;
  font-size: 10px;
  text-align: start;
  border: 1.5px solid #4176cd;
  padding-left: 10px;
}

.th3 {
  width: 115px;
}

.th4 {
  width: 151px;
}

.th5 {
  width: 191px;
}

.th6 {
  width: 168px;
}

.th7 {
  width: 100px;
}

.th8 {
  width: 50px;
}

.th9 {
  width: 120px;
}

.priceTotalContainer {
  background-color: #808081;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
}

.boxPrice {
  display: flex;
  align-items: center;
  gap: 20px;
}

.contentTitleContract {
  background-color: #4176cd;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: center;
  font-size: 14px;
}

.containerContract {
  padding: 8px 3px;
}

.textGrid {
  width: 380px;
  font-size: 12px;
  text-align: start;
}

.textBold {
  font-size: 12px;
  text-align: start;
  font-weight: 600;
}

.textContent {
  font-size: 12px;
  text-align: start;
  font-weight: 400;
}

.boxText {
  display: flex;
  align-items: center;
  gap: 5px;
}

.boxText2 {
  display: flex;
  align-items: flex-start;
  gap: 5px;
}

.textBold1 {
  font-size: 12px;
  text-align: start;
  font-weight: 600;
  margin-right: 31px;
}

.textBold2 {
  font-size: 12px;
  text-align: start;
  font-weight: 600;
  margin-right: 69px;
}

.textBold3 {
  font-size: 12px;
  text-align: start;
  font-weight: 600;
  margin-right: 10px;
}

.textBold4 {
  font-size: 12px;
  text-align: start;
  font-weight: 600;
  margin-right: 32px;
}

.textContent2 {
  font-size: 12px;
  text-align: start;
  font-weight: 400;
  margin-top: 20px;
  width: 400px;
}

.textBold5 {
  font-size: 12px;
  text-align: start;
  font-weight: 600;
  margin-top: 32px;
}

/* NATIONAL DISTRIBUTOR */

.container2 {
  border: 1px solid #d7d7d7;
  border-radius: 8px;
  margin: 50px 40px;
}

.img2 {
  margin: 20px 0 0 20px;
}

.textTitleCotation2 {
  font-size: 16px;
  font-weight: 500;
  margin-top: 30px;
}

.boxContainer2 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.titleInput2 {
  font-size: 12px;
}

.boxInput2 {
  border: 1px solid #d7d7d7;
  width: 100%;
  height: 42px;
  border-radius: 8px;
  display: flex;
  padding: 0 10px;

  align-items: center;
  justify-content: flex-start;
}

.valueInput2 {
  font-size: 12px;
}

.boxTextarea2 {
  border: 1px solid #d7d7d7;
  width: 100%;
  height: 90px;
  border-radius: 8px;
  padding: 10px;
}

.containerBoxLogo2 {
  padding: 20px 40px;
}

.headerTitle2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.proposal2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.contentTitle2 {
  background-color: #4176cd;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.boxContentTitle2 {
  display: flex;
  align-items: center;
  gap: 38px;
}

.boxContentTitle2 p {
  font-size: 14px;
}

.textTitleContent2 {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.contentValue2 {
  margin-left: 10px;
}

.contentValueBox2 {
  display: flex;
  align-items: center;
  gap: 9px;
}

.contentBox2 {
  padding: 0 20px 20px;
}

/* ARMAZENAGEM */

.container3 {
  border: 1px solid #d7d7d7;
  border-radius: 8px;
  margin: 50px 40px;
}

.img3 {
  margin: 20px 0 0 20px;
}

.textTitleCotation3 {
  font-size: 16px;
  font-weight: 500;
  margin-top: 30px;
}

.boxContainer3 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
}

.titleInput3 {
  font-size: 12px;
}

.containerInput3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.boxInput3 {
  border: 1px solid #d7d7d7;
  width: 100%;
  height: 42px;
  border-radius: 8px;
  display: flex;
  padding: 0 10px;

  align-items: center;
  justify-content: flex-start;
}

.valueInput3 {
  font-size: 12px;
}

.boxTextarea3 {
  border: 1px solid #d7d7d7;
  width: 100%;
  height: 90px;
  border-radius: 8px;
  padding: 10px;
}

.containerBoxLogo3 {
  padding: 20px 40px;
}

.headerTitle3 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.proposal3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.contentTitle3 {
  background-color: #4176cd;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.boxContentTitle3 {
  display: flex;
  align-items: center;
  gap: 38px;
}

.boxContentTitle3 p {
  font-size: 14px;
}

.textTitleContent3 {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.contentValue3 {
  margin-left: 10px;
}

.contentValueBox3 {
  display: flex;
  align-items: center;
  gap: 9px;
}

.contentBox3 {
  padding: 0 20px 20px;
}

/* AIR BOX */
.container4 {
  border: 1px solid #d7d7d7;
  border-radius: 8px;
  margin: 50px 40px;
}

.img4 {
  margin: 20px 0 0 20px;
}

.textTitleCotation4 {
  font-size: 16px;
  font-weight: 500;
  margin-top: 30px;
}

.boxContainer4 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
}

.titleInput4 {
  font-size: 11.5px;
  white-space: nowrap;
}

.containerInput4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.containerInputTwoInputs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 65%;
}

.boxInput4 {
  border: 1px solid #d7d7d7;
  width: 100%;
  height: 42px;
  border-radius: 8px;
  display: flex;
  padding: 0 10px;

  align-items: center;
  justify-content: flex-start;
}

.valueInput4 {
  font-size: 12px;
}

.boxTextarea4 {
  border: 1px solid #d7d7d7;
  width: 100%;
  height: 90px;
  border-radius: 8px;
  padding: 10px;
}

.containerBoxLogo4 {
  padding: 20px 40px;
}

.headerTitle4 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.proposal4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.textSelectTypeAcess {
  font-family: Popins-regular;
  font-size: 13px;
  font-weight: 600;
  color: #000;
  white-space: nowrap;
}

.contentTitle4 {
  background-color: #4176cd;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.boxContentTitle4 {
  display: flex;
  align-items: center;
  gap: 38px;
}

.boxContentTitle4 p {
  font-size: 14px;
}

.textTitleContent4 {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.contentValue4 {
  margin-left: 10px;
}

.contentValueBox4 {
  display: flex;
  align-items: center;
  gap: 9px;
}

.contentBox4 {
  padding: 0 20px 20px;
}

.textKMRodad {
  font-family: Popins-Regular;
  color: var(--color-primary);
  font-weight: 500;
  font-size: 14px;
}

.transformY5 {
  transform: translateY(5px);
}

.headerProposal {
  font-family: Popins-Regular;
  color: #000;
  font-weight: 500;
  font-size: 17px;
}

.statusProposal {
  height: 29px;
  font-family: Popins-Regular;
  color: #c6b200;
  font-weight: 500;
  background-color: #fff7aa;
  border-radius: 100px;
  font-size: 11px;
  padding: 8px 12px;
}

.headerDetailsProposal {
  font-family: Popins-Regular;
  color: #000;
  font-weight: 500;
  font-size: 14px;
  white-space: nowrap;
}

.contentDetailsProposal {
  font-family: Popins-Regular;
  color: #6a6a6a;
  font-size: 14px;
}

.refusedProposal {
  color: #850000;
  background-color: #db0d3393;
  font-size: 11px;
  border-radius: 8px;
  padding: 4px 10px;
}

.approvedProposal {
  color: #42982d;
  background-color: #a8fd8b;
  font-size: 11px;
  border-radius: 8px;
  padding: 4px 10px;
}

.waitingProposal {
  color: #9f7f0d;
  background-color: #ffe073;
  font-size: 11px;
  border-radius: 8px;
  padding: 4px 10px;
}

.approvedProposalAdmin {
  color: #187900;
  background-color: #3ef800;
  font-size: 11px;
  border-radius: 8px;
  padding: 4px 10px;
}

.advanceDiscount {
  color: #ffffff;
  background-color: #4935fa;
  font-size: 11px;
  border-radius: 8px;
  padding: 4px 10px;
}

.ApprovedWithConditions {
  color: #9d007a;
  background-color: #9d007a50;
  font-size: 11px;
  border-radius: 8px;
  padding: 4px 10px;
}

.titleDiscontProposal {
  font-size: 15px;
  font-weight: 600;
}

.contentDiscontProposal {
  font-size: 15px;
}

.contentDiscontProposal span {
  font-weight: 600;
}

.applicationOrRequestProposal {
  font-weight: 500;
  padding: 0 10px;
  cursor: pointer;
}
.selectOptionDiscount {
  border-bottom: 2px solid var(--color-primary);
}

.modal-filter-table-list-user {
  max-width: 700px;
}

::-webkit-scrollbar {
  width: 9px;
  height: 6px;
  background: #d8d8d8;
  border-radius: 50px;
}

.scrollLowerUp::-webkit-scrollbar {
  height: 7px;
  cursor: pointer;
}

.padding-prime input {
  padding: 9px 10px;
  border-radius: 8px;
  outline: none;
  box-shadow: none;
  border-color: #d7d7d7;
}

.inputMerchandise {
  padding: 9px 10px !important;
  border-radius: 10px;
  outline: none;
  box-shadow: none;
  border: 1px solid #d7d7d7 !important;
}

.currencyMerchandise {
  width: 300px !important;
}

.currencyTable input {
  width: 300px;
}

.cubage input {
  width: 110px;
  padding: 10px 10px;
  outline: none;
  background-color: #5c5b5b15;
}

.pesoCubage input {
  width: 110px;
  padding: 10px 10px;
  border-radius: 10px;
  outline: none;
  box-shadow: none;
  border: 1px solid #d7d7d7 !important;
}

.p-calendar .p-inputtext {
  padding: 7px 10px;
  border: 2px solid #d7d7d7;
}

.labelCheckMaritime {
  font-size: 13px;
  display: flex;
  align-items: center;
}

.labelCheckMaritime input {
  margin-right: 10px;
}

.textSelectFilterManagerCommun {
}

.inputMaritime {
  outline: none !important;
  border: 1px solid #d7d7d7 !important;
  border-radius: 7px !important;
  padding: 8px 10px !important;
}

.inputNumberMaritime input {
  outline: none !important;
  border: 1px solid #d7d7d7 !important;
  border-radius: 7px !important;
  padding: 8px 10px !important;
}

.inputNumberTwoMaritime input {
  outline: none !important;
  border: 1px solid #d7d7d7 !important;
  border-radius: 7px !important;
  padding: 8px 10px !important;
  width: 280px !important;
}

.calendarMaritime input {
  outline: none !important;
  border: 1px solid #d7d7d7 !important;
  border-radius: 7px !important;
  border-end-end-radius: 0 !important;
  border-start-end-radius: 0 !important;
  padding: 8px 10px !important;
}

.selecatMaritime {
  outline: none !important;
  border: 1px solid #d7d7d7 !important;
  border-radius: 7px !important;
  padding: 8px 10px !important;
  width: 280px !important;
}

.p-datepicker-month {
  margin-right: 10px !important;
}

#selectTable {
  padding: 10px !important;
  border: 1px solid #d7d7d7 !important;
  border-radius: 10px !important;
  box-shadow: none;
}

#ftladdress {
  padding: 10px !important;
  border: 1px solid #d7d7d7 !important;
  border-radius: 6px !important;
  /* box-shadow: none; */
}

.p-dropdown-filter {
  padding: 7px 10px !important;
}

.p-dropdown-filter-container svg {
  transform: translateY(-5px);
}

.selectDedicado {
  min-width: 220px !important;
}

.selectDedicado .css-13cymwt-control,
.selectDedicado .css-1dimb5e-singleValue {
  min-width: 200px !important;
}

.selectDedicado .css-hlgwow {
  padding: 6px 12px;
}

.textMutipleMeasure {
  text-align: center;
}

/* Track */
::-webkit-scrollbar-track {
  background: #d8d8d8;
  border-radius: 10px;
  height: 35px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.33);
  border-radius: 10px;
  max-width: 10;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

@media (min-width: 1326px) {
  .boxContainerHeader {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .boxContainerCard {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .containerCard {
    max-width: 1000px;
  }

  .containerHeader {
    width: 1000px;
  }

  .containerBox {
    width: 1000px;
  }
}

/* ── Login Layout ────────────────────────────────────────── */

.login-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 100vh;
}

.login-col1 {
  grid-column: 1 / 2;
}

.login-col2 {
  grid-column: 2 / 3;
}

.login-image-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 110px 52px;
  background: var(--backgroundDashboard);
}

.login-image {
  height: 100%;
  max-height: 500px;
  object-fit: contain;
}

.login-form-container {
  padding-top: 7.5rem;
  padding-left: 3rem;
  padding-right: 3rem;
}

.login-form-inner {
  width: 418px;
  max-width: 100%;
}

.login-btn-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .login-layout {
    grid-template-columns: 1fr;
  }

  .login-col1 {
    display: none;
  }

  .login-col2 {
    grid-column: 1 / 2;
  }

  .login-form-container {
    padding-top: 3rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .login-form-inner {
    width: 100%;
  }

  .login-form-inner input {
    width: 100% !important;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;;EAEnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;;EAErB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,4CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,4CAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,4CAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;;EAErB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;;EAExB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;;EAElB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;;EAExB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;;EAExB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;;EAErB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,QAAQ;;AAER;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yBAAyB;;AAEzB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;;EAEf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA,gBAAgB;;AAEhB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;;EAEf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;;EAEf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,mCAAmC;EACnC,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Comfortaa:wght@300;400;500;600;700&display=swap\");\n\nbody {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n}\n\np {\n  margin-bottom: 0;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n:root {\n  /* Primary Palette */\n  --color-primary: #123164;\n  --background: #e5e5e5;\n  --backgroundDashboard: #f7f9fb;\n  --negative: #ea0000;\n\n  /* Grey Scale Palette */\n  --white: #ffffff;\n  --grey-0: #d7d7d7;\n  --grey-1: #a0a0a0;\n  --grey-2: #3c3c43;\n\n  --hover: #f7f9fb;\n\n  /* Typography */\n  --title-1: 1.5rem;\n  --title-2: 0.9375rem;\n  --content: 0.875rem;\n  --content-2: 0.8125rem;\n  --button: 1.125rem;\n  --button-2: 0.9375rem;\n\n  /* Cart */\n  --amount: 0.625rem;\n}\n\n@font-face {\n  font-family: Popins-regular;\n  src: url(\"./fonts/Poppins/Poppins-Regular.ttf\");\n}\n\n@font-face {\n  font-family: Popins-Medium;\n  src: url(\"./fonts/Poppins/Poppins-Medium.ttf\");\n}\n\n@font-face {\n  font-family: Popins-SemiBold;\n  src: url(\"./fonts/Poppins/Poppins-SemiBold.ttf\");\n}\n\n@font-face {\n  font-family: Comforta-Regular;\n  src: url(\"./fonts/Comfortaa/Comfortaa-Regular.ttf\");\n}\n\n.textPrimaryLanding {\n  margin-top: 2.125rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 2.5rem;\n\n  font-family: Popins-regular;\n  color: #123164;\n}\n\n.textPrimaryLabelInput {\n  font-family: Popins-regular;\n  color: black;\n  font-weight: 400;\n  font-size: 0.875rem;\n}\n\n.textPrimaryInput {\n  font-family: Popins-regular;\n  font-weight: 500;\n  font-size: 0.975rem;\n  padding: 0 15px;\n  color: #5c5b5b;\n}\n\n.textErrorInput {\n  color: red;\n  font-family: Popins-regular;\n  position: absolute;\n  top: 87px;\n  font-size: 0.975rem;\n}\n\n.textPrimaryButton {\n  color: white;\n  font-family: Popins-regular;\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.textForgotPassword {\n  color: var(--color-primary);\n  font-family: Popins-regular;\n}\n\n.textPrimaryForgotPassword {\n  margin-top: 2.125rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.0625rem;\n\n  font-family: Popins-regular;\n  color: var(--color-primary);\n}\n\n.textDescriptionForgotPassword {\n  font-family: Popins-regular;\n  font-weight: 400;\n  font-size: 15px;\n  color: var(--black);\n  margin-bottom: 2.125rem;\n}\n\n.textPrimarySendMail {\n  margin-top: 2.125rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.0625rem;\n  text-align: center;\n\n  font-family: Popins-regular;\n  color: var(--color-primary);\n}\n\n.textDescriptionSendMail {\n  font-family: Popins-regular;\n  font-weight: 400;\n  font-size: 15px;\n  color: var(--black);\n  text-align: center;\n}\n\n.textPrimaryResetPassword {\n  margin-top: 2.125rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.0625rem;\n\n  font-family: Popins-regular;\n  color: var(--color-primary);\n}\n\n.textPrimaryRegister {\n  margin-top: 2.125rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.0625rem;\n\n  font-family: Popins-regular;\n  color: var(--color-primary);\n}\n\n.textDescriptionResetPassword {\n  font-family: Popins-regular;\n  font-weight: 400;\n  font-size: 15px;\n  color: var(--black);\n  margin-bottom: 1.6875rem;\n}\n\n.textPrimaryLabelInput {\n  font-family: Popins-regular;\n  color: black;\n  font-weight: 400;\n  font-size: 0.875rem;\n}\n\n.textLabelInputSelectFilterManager {\n  font-family: Popins-regular;\n  color: black;\n  font-weight: 400;\n  font-size: 0.875rem;\n  margin-bottom: 14px;\n}\n\n.textTitleTermsRegister {\n  font-family: Popins-regular;\n  color: black;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.textDescriptionTermsRegister {\n  font-family: Popins-regular;\n  color: black;\n  font-weight: 500;\n  font-size: 0.8125rem;\n}\n\n.textTermsModalRegister {\n  font-family: Popins-regular;\n  color: var(--color-primary);\n  font-weight: 600;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.textFooterRegisterTitle {\n  font-family: Popins-regular;\n  color: var(--grey-2);\n  font-weight: 500;\n  font-size: 0.9375rem;\n}\n\n.textFooterRegisterContent {\n  font-family: Popins-regular;\n  color: var(--color-primary);\n  font-weight: 500;\n  font-size: 0.9375rem;\n}\n\n.textCheckedSidebar {\n  font-family: Popins-regular;\n  color: var(--white);\n  font-weight: 500;\n  font-size: 15px;\n  margin-bottom: 0;\n}\n\n.textNotCheckedSidebar {\n  font-family: Popins-regular;\n  color: var(--color-primary);\n  font-weight: 600;\n  font-size: 15px;\n  margin-bottom: 0;\n}\n\n.textTitleCardQuotation {\n  font-family: Popins-regular;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.textDescriptionCardQuotation {\n  font-family: Popins-regular;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.textTitleTypeDispatch {\n  font-family: Popins-regular;\n  color: #000000;\n  font-weight: 600;\n  font-size: 17px;\n}\n\n.textDescriptionTypeDispatch {\n  font-family: Popins-regular;\n  color: #000000;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.textPrimaryHeaderDashboard {\n  font-family: Popins-regular;\n  font-weight: 600;\n  font-size: 30px;\n  color: #062f67;\n}\n\n.textUploadImg {\n  font-family: Popins-regular;\n  color: #000000;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.textAddNewRoute {\n  font-family: Popins-regular;\n  font-weight: 600;\n  font-size: 15px;\n  color: #062f67;\n}\n\n.textRemoveNewRoute {\n  font-family: Popins-regular;\n  font-weight: 600;\n  font-size: 15px;\n  color: #ea0000;\n}\n\n.textTitleSummary {\n  font-family: Popins-regular;\n  font-weight: 600;\n  font-size: 15px;\n  color: #6a6a6a;\n}\n\n.textPrimaryLoginAdm {\n  margin-top: 2.125rem;\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 2.5rem;\n\n  font-family: Popins-regular;\n  color: #123164;\n}\n\n.textTitleShippingCard {\n  font-family: Popins-regular;\n  font-size: 0.875remx;\n  font-weight: 600;\n  color: #000000;\n  white-space: nowrap;\n  width: 95%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.textTypeShippingCard {\n  font-family: Popins-regular;\n  font-size: 14px;\n  font-weight: 500;\n  color: #808080;\n}\n\n.textTypeValueShippingCard {\n  font-family: Popins-regular;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #000000;\n}\n\n.textTypeValueShippingCardPoints {\n  font-family: Popins-regular;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #000000;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: \"20px\";\n  cursor: pointer;\n}\n\n.textModalTitleOption {\n  font-family: Popins-regular;\n  font-size: 17px;\n  font-weight: 600;\n  color: #000000;\n}\n\n.textModalContentOption {\n  font-family: Popins-regular;\n  font-size: 17px;\n  font-weight: 600;\n  color: #ea0000;\n}\n\n.textNameTableListUser {\n  font-family: Popins-Medium;\n  color: #6a6a6a;\n  font-size: 0.87rem;\n  text-align: center;\n  width: 170px;\n  position: relative;\n  top: -6px;\n}\n\n.textNameTableListUserTwo {\n  font-family: Popins-Medium;\n  color: #6a6a6a;\n  font-size: 0.87rem;\n  text-align: center;\n  width: 170px;\n}\n\n.textPrimaryModalFilterManager {\n  font-family: Popins-Medium;\n  font-size: 1.125rem;\n  margin-left: 18px;\n}\n\n.textModalTableListUserEditPrimary {\n  font-family: Popins-Medium;\n  color: #030303;\n  font-size: 1.12rem;\n}\n\n.textUpAddIcon {\n  font-family: Popins-Medium;\n  color: var(--color-primary);\n  font-weight: 500;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.textAddBlock {\n  font-family: Popins-Medium;\n  color: var(--color-primary);\n  font-weight: 500;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.textNameTableListManager {\n  font-family: Popins-Regular;\n  color: #000000;\n  font-weight: 500;\n  font-size: 12px;\n  transform: translateY(2px);\n}\n\n.textModalTableListUserEditSecondary {\n  font-family: Popins-Medium;\n  color: #ea0000;\n  font-weight: 500;\n  font-size: 1.12rem;\n}\n\n.modal-filter-table-list-user-edit {\n  width: 24.414vw;\n  max-width: 24.414vw;\n  border-radius: 20px;\n}\n\n.modal-filter-table-list-user {\n  width: 74.414vw;\n  max-width: 46vw;\n}\n\n.errorMessage {\n  font-family: Popins-regular;\n  color: red;\n  font-size: 0.9rem;\n  position: absolute;\n  top: 84px;\n  left: 2px;\n}\n\n.textBtnFilterManagerModal {\n  font-family: Popins-Medium;\n  font-size: 0.938rem;\n  color: white;\n}\n\n.textConfirmationRemove {\n  font-family: Popins-regular;\n  font-size: 1.12rem;\n  text-align: center;\n  margin-top: 1.37rem;\n}\n\n.textBtnRemove {\n  font-family: Popins-Medium;\n  color: #ea0000;\n  font-size: 0.93rem;\n}\n\n.textPrimaryModalFilterManager {\n  font-family: Popins-Medium;\n  font-size: 1.125rem;\n  margin-left: 18px;\n}\n\n.textBtnFilterManager {\n  color: white;\n  font-family: Popins-Medium;\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.textTitleCardBlackList {\n  color: #101828;\n  font-family: Popins-Medium;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.textTypeCardBlackList {\n  color: #808080;\n  font-family: Popins-Medium;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.textContentCardBlackList {\n  color: #1a1a1a;\n  font-family: Popins-Medium;\n  font-weight: 500;\n  font-size: 14px;\n  max-width: 232px;\n  text-align: end;\n}\n\n.textAddRouteCard {\n  font-family: Popins-Medium;\n  color: var(--color-primary);\n  font-size: 0.93rem;\n}\n\n.textRemoveRouteCard {\n  font-family: Popins-Medium;\n  color: var(--negative);\n  font-size: 0.93rem;\n}\n\n.textTitleModalQuotation {\n  font-family: Popins-Medium;\n  color: var(--color-primary);\n  font-size: 1.3125rem;\n  text-align: center;\n}\n\n.textDescriptionModalQuotation {\n  font-family: Popins-Regular;\n  color: #000;\n  font-size: 0.875rem;\n  line-height: 20px;\n  text-align: center;\n}\n\n.textTitleFooterLogin {\n  font-size: 0.9375rem;\n  font-family: Popins-Medium;\n  font-weight: 500;\n  color: #3c3c4399;\n}\n\n.textContentFooterLogin {\n  font-size: 0.9375rem;\n  font-family: Popins-Medium;\n  color: var(--color-primary);\n  font-weight: 500;\n  cursor: pointer;\n}\n\n/* PDF */\n\n.containerPdf {\n  margin: 50px 40px;\n  border: 1.5px solid #4176cd;\n}\n\n.containerBoxLogo {\n  padding: 20px 40px;\n}\n\n.headerTitle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.proposal {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.contentTitle {\n  background-color: #4176cd;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n\n.boxContentTitle {\n  display: flex;\n  align-items: center;\n  gap: 38px;\n}\n\n.boxContentTitle p {\n  font-size: 10px;\n}\n\n.textTitleContent {\n  font-size: 14px;\n  color: #000;\n  font-weight: 600;\n}\n\n.contentValue {\n  margin-left: 10px;\n}\n\n.contentValueBox {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.contentBoxValueAddressee {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  position: relative;\n  width: 49%;\n}\n\n.beam {\n  min-height: 23px;\n  max-width: 2px;\n  background-color: #4176cd80;\n  position: absolute;\n  top: 19px;\n  left: 56px;\n}\n\n.contentBoxValueAddressee div {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n}\n\n.translateAddress {\n  transform: translateY(10px);\n}\n\n.cardTitleAddressee {\n  font-size: 11px;\n  font-weight: 400;\n  width: 54%;\n}\n\n.emailBoxAddressee {\n  transform: translateY(-20px);\n}\n\n.cardContetAddressee {\n  font-size: 11px;\n  font-weight: 600;\n  width: 100%;\n  background-color: #d7d7d7;\n  padding-left: 10px;\n}\n\n.containerCargoData {\n  display: flex;\n  align-items: center;\n}\n\n.contentTitleCargoData {\n  background-color: #4176cd;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n  display: flex;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.table-container {\n  width: 100%;\n}\n\n.headerTable {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.thTable-left {\n  font-weight: 600;\n  font-size: 10px;\n  text-align: start;\n  border: 1.5px solid #4176cd;\n  padding-left: 10px;\n  width: 150px;\n}\n\n.contentBoxValueCargoData {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding: 10px 5px;\n  position: relative;\n  width: 50%;\n}\n\n.contentBoxValueCargoData div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 300px;\n}\n\n.cardTitleCargoData {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.cardContetCargoData {\n  font-size: 14px;\n  font-weight: 600;\n  width: 100%;\n  background-color: #d7d7d7;\n  padding-left: 10px;\n}\n\n.cardContetCargoDataNotColor {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.cardContetCargoDataYesColor {\n  font-size: 14px;\n  font-weight: 500;\n  background-color: #f924244f;\n  padding: 0 20px;\n}\n\n.thTable {\n  font-weight: 600;\n  font-size: 13px;\n  text-align: center;\n  border: 1.5px solid #4176cd;\n}\n\n.tdTable {\n  font-weight: 400;\n  font-size: 10px;\n  text-align: start;\n  border: 1.5px solid #4176cd;\n  padding-left: 10px;\n}\n\n.th3 {\n  width: 115px;\n}\n\n.th4 {\n  width: 151px;\n}\n\n.th5 {\n  width: 191px;\n}\n\n.th6 {\n  width: 168px;\n}\n\n.th7 {\n  width: 100px;\n}\n\n.th8 {\n  width: 50px;\n}\n\n.th9 {\n  width: 120px;\n}\n\n.priceTotalContainer {\n  background-color: #808081;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  justify-content: flex-end;\n  font-size: 14px;\n}\n\n.boxPrice {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.contentTitleContract {\n  background-color: #4176cd;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.containerContract {\n  padding: 8px 3px;\n}\n\n.textGrid {\n  width: 380px;\n  font-size: 12px;\n  text-align: start;\n}\n\n.textBold {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 600;\n}\n\n.textContent {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 400;\n}\n\n.boxText {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.boxText2 {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n}\n\n.textBold1 {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 600;\n  margin-right: 31px;\n}\n\n.textBold2 {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 600;\n  margin-right: 69px;\n}\n\n.textBold3 {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 600;\n  margin-right: 10px;\n}\n\n.textBold4 {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 600;\n  margin-right: 32px;\n}\n\n.textContent2 {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 400;\n  margin-top: 20px;\n  width: 400px;\n}\n\n.textBold5 {\n  font-size: 12px;\n  text-align: start;\n  font-weight: 600;\n  margin-top: 32px;\n}\n\n/* NATIONAL DISTRIBUTOR */\n\n.container2 {\n  border: 1px solid #d7d7d7;\n  border-radius: 8px;\n  margin: 50px 40px;\n}\n\n.img2 {\n  margin: 20px 0 0 20px;\n}\n\n.textTitleCotation2 {\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 30px;\n}\n\n.boxContainer2 {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.titleInput2 {\n  font-size: 12px;\n}\n\n.boxInput2 {\n  border: 1px solid #d7d7d7;\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  display: flex;\n  padding: 0 10px;\n\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.valueInput2 {\n  font-size: 12px;\n}\n\n.boxTextarea2 {\n  border: 1px solid #d7d7d7;\n  width: 100%;\n  height: 90px;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.containerBoxLogo2 {\n  padding: 20px 40px;\n}\n\n.headerTitle2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.proposal2 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.contentTitle2 {\n  background-color: #4176cd;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n\n.boxContentTitle2 {\n  display: flex;\n  align-items: center;\n  gap: 38px;\n}\n\n.boxContentTitle2 p {\n  font-size: 14px;\n}\n\n.textTitleContent2 {\n  font-size: 14px;\n  color: #000;\n  font-weight: 600;\n}\n\n.contentValue2 {\n  margin-left: 10px;\n}\n\n.contentValueBox2 {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.contentBox2 {\n  padding: 0 20px 20px;\n}\n\n/* ARMAZENAGEM */\n\n.container3 {\n  border: 1px solid #d7d7d7;\n  border-radius: 8px;\n  margin: 50px 40px;\n}\n\n.img3 {\n  margin: 20px 0 0 20px;\n}\n\n.textTitleCotation3 {\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 30px;\n}\n\n.boxContainer3 {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.titleInput3 {\n  font-size: 12px;\n}\n\n.containerInput3 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.boxInput3 {\n  border: 1px solid #d7d7d7;\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  display: flex;\n  padding: 0 10px;\n\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.valueInput3 {\n  font-size: 12px;\n}\n\n.boxTextarea3 {\n  border: 1px solid #d7d7d7;\n  width: 100%;\n  height: 90px;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.containerBoxLogo3 {\n  padding: 20px 40px;\n}\n\n.headerTitle3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.proposal3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.contentTitle3 {\n  background-color: #4176cd;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n\n.boxContentTitle3 {\n  display: flex;\n  align-items: center;\n  gap: 38px;\n}\n\n.boxContentTitle3 p {\n  font-size: 14px;\n}\n\n.textTitleContent3 {\n  font-size: 14px;\n  color: #000;\n  font-weight: 600;\n}\n\n.contentValue3 {\n  margin-left: 10px;\n}\n\n.contentValueBox3 {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.contentBox3 {\n  padding: 0 20px 20px;\n}\n\n/* AIR BOX */\n.container4 {\n  border: 1px solid #d7d7d7;\n  border-radius: 8px;\n  margin: 50px 40px;\n}\n\n.img4 {\n  margin: 20px 0 0 20px;\n}\n\n.textTitleCotation4 {\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 30px;\n}\n\n.boxContainer4 {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.titleInput4 {\n  font-size: 11.5px;\n  white-space: nowrap;\n}\n\n.containerInput4 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.containerInputTwoInputs {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  width: 65%;\n}\n\n.boxInput4 {\n  border: 1px solid #d7d7d7;\n  width: 100%;\n  height: 42px;\n  border-radius: 8px;\n  display: flex;\n  padding: 0 10px;\n\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.valueInput4 {\n  font-size: 12px;\n}\n\n.boxTextarea4 {\n  border: 1px solid #d7d7d7;\n  width: 100%;\n  height: 90px;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.containerBoxLogo4 {\n  padding: 20px 40px;\n}\n\n.headerTitle4 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.proposal4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.textSelectTypeAcess {\n  font-family: Popins-regular;\n  font-size: 13px;\n  font-weight: 600;\n  color: #000;\n  white-space: nowrap;\n}\n\n.contentTitle4 {\n  background-color: #4176cd;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n\n.boxContentTitle4 {\n  display: flex;\n  align-items: center;\n  gap: 38px;\n}\n\n.boxContentTitle4 p {\n  font-size: 14px;\n}\n\n.textTitleContent4 {\n  font-size: 14px;\n  color: #000;\n  font-weight: 600;\n}\n\n.contentValue4 {\n  margin-left: 10px;\n}\n\n.contentValueBox4 {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.contentBox4 {\n  padding: 0 20px 20px;\n}\n\n.textKMRodad {\n  font-family: Popins-Regular;\n  color: var(--color-primary);\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.transformY5 {\n  transform: translateY(5px);\n}\n\n.headerProposal {\n  font-family: Popins-Regular;\n  color: #000;\n  font-weight: 500;\n  font-size: 17px;\n}\n\n.statusProposal {\n  height: 29px;\n  font-family: Popins-Regular;\n  color: #c6b200;\n  font-weight: 500;\n  background-color: #fff7aa;\n  border-radius: 100px;\n  font-size: 11px;\n  padding: 8px 12px;\n}\n\n.headerDetailsProposal {\n  font-family: Popins-Regular;\n  color: #000;\n  font-weight: 500;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.contentDetailsProposal {\n  font-family: Popins-Regular;\n  color: #6a6a6a;\n  font-size: 14px;\n}\n\n.refusedProposal {\n  color: #850000;\n  background-color: #db0d3393;\n  font-size: 11px;\n  border-radius: 8px;\n  padding: 4px 10px;\n}\n\n.approvedProposal {\n  color: #42982d;\n  background-color: #a8fd8b;\n  font-size: 11px;\n  border-radius: 8px;\n  padding: 4px 10px;\n}\n\n.waitingProposal {\n  color: #9f7f0d;\n  background-color: #ffe073;\n  font-size: 11px;\n  border-radius: 8px;\n  padding: 4px 10px;\n}\n\n.approvedProposalAdmin {\n  color: #187900;\n  background-color: #3ef800;\n  font-size: 11px;\n  border-radius: 8px;\n  padding: 4px 10px;\n}\n\n.advanceDiscount {\n  color: #ffffff;\n  background-color: #4935fa;\n  font-size: 11px;\n  border-radius: 8px;\n  padding: 4px 10px;\n}\n\n.ApprovedWithConditions {\n  color: #9d007a;\n  background-color: #9d007a50;\n  font-size: 11px;\n  border-radius: 8px;\n  padding: 4px 10px;\n}\n\n.titleDiscontProposal {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.contentDiscontProposal {\n  font-size: 15px;\n}\n\n.contentDiscontProposal span {\n  font-weight: 600;\n}\n\n.applicationOrRequestProposal {\n  font-weight: 500;\n  padding: 0 10px;\n  cursor: pointer;\n}\n.selectOptionDiscount {\n  border-bottom: 2px solid var(--color-primary);\n}\n\n.modal-filter-table-list-user {\n  max-width: 700px;\n}\n\n::-webkit-scrollbar {\n  width: 9px;\n  height: 6px;\n  background: #d8d8d8;\n  border-radius: 50px;\n}\n\n.scrollLowerUp::-webkit-scrollbar {\n  height: 7px;\n  cursor: pointer;\n}\n\n.padding-prime input {\n  padding: 9px 10px;\n  border-radius: 8px;\n  outline: none;\n  box-shadow: none;\n  border-color: #d7d7d7;\n}\n\n.inputMerchandise {\n  padding: 9px 10px !important;\n  border-radius: 10px;\n  outline: none;\n  box-shadow: none;\n  border: 1px solid #d7d7d7 !important;\n}\n\n.currencyMerchandise {\n  width: 300px !important;\n}\n\n.currencyTable input {\n  width: 300px;\n}\n\n.cubage input {\n  width: 110px;\n  padding: 10px 10px;\n  outline: none;\n  background-color: #5c5b5b15;\n}\n\n.pesoCubage input {\n  width: 110px;\n  padding: 10px 10px;\n  border-radius: 10px;\n  outline: none;\n  box-shadow: none;\n  border: 1px solid #d7d7d7 !important;\n}\n\n.p-calendar .p-inputtext {\n  padding: 7px 10px;\n  border: 2px solid #d7d7d7;\n}\n\n.labelCheckMaritime {\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n}\n\n.labelCheckMaritime input {\n  margin-right: 10px;\n}\n\n.textSelectFilterManagerCommun {\n}\n\n.inputMaritime {\n  outline: none !important;\n  border: 1px solid #d7d7d7 !important;\n  border-radius: 7px !important;\n  padding: 8px 10px !important;\n}\n\n.inputNumberMaritime input {\n  outline: none !important;\n  border: 1px solid #d7d7d7 !important;\n  border-radius: 7px !important;\n  padding: 8px 10px !important;\n}\n\n.inputNumberTwoMaritime input {\n  outline: none !important;\n  border: 1px solid #d7d7d7 !important;\n  border-radius: 7px !important;\n  padding: 8px 10px !important;\n  width: 280px !important;\n}\n\n.calendarMaritime input {\n  outline: none !important;\n  border: 1px solid #d7d7d7 !important;\n  border-radius: 7px !important;\n  border-end-end-radius: 0 !important;\n  border-start-end-radius: 0 !important;\n  padding: 8px 10px !important;\n}\n\n.selecatMaritime {\n  outline: none !important;\n  border: 1px solid #d7d7d7 !important;\n  border-radius: 7px !important;\n  padding: 8px 10px !important;\n  width: 280px !important;\n}\n\n.p-datepicker-month {\n  margin-right: 10px !important;\n}\n\n#selectTable {\n  padding: 10px !important;\n  border: 1px solid #d7d7d7 !important;\n  border-radius: 10px !important;\n  box-shadow: none;\n}\n\n#ftladdress {\n  padding: 10px !important;\n  border: 1px solid #d7d7d7 !important;\n  border-radius: 6px !important;\n  /* box-shadow: none; */\n}\n\n.p-dropdown-filter {\n  padding: 7px 10px !important;\n}\n\n.p-dropdown-filter-container svg {\n  transform: translateY(-5px);\n}\n\n.selectDedicado {\n  min-width: 220px !important;\n}\n\n.selectDedicado .css-13cymwt-control,\n.selectDedicado .css-1dimb5e-singleValue {\n  min-width: 200px !important;\n}\n\n.selectDedicado .css-hlgwow {\n  padding: 6px 12px;\n}\n\n.textMutipleMeasure {\n  text-align: center;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #d8d8d8;\n  border-radius: 10px;\n  height: 35px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.33);\n  border-radius: 10px;\n  max-width: 10;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n@media (min-width: 1326px) {\n  .boxContainerHeader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .boxContainerCard {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .containerCard {\n    max-width: 1000px;\n  }\n\n  .containerHeader {\n    width: 1000px;\n  }\n\n  .containerBox {\n    width: 1000px;\n  }\n}\n\n/* ── Login Layout ────────────────────────────────────────── */\n\n.login-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  min-height: 100vh;\n}\n\n.login-col1 {\n  grid-column: 1 / 2;\n}\n\n.login-col2 {\n  grid-column: 2 / 3;\n}\n\n.login-image-container {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 110px 52px;\n  background: var(--backgroundDashboard);\n}\n\n.login-image {\n  height: 100%;\n  max-height: 500px;\n  object-fit: contain;\n}\n\n.login-form-container {\n  padding-top: 7.5rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n\n.login-form-inner {\n  width: 418px;\n  max-width: 100%;\n}\n\n.login-btn-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@media (max-width: 768px) {\n  .login-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .login-col1 {\n    display: none;\n  }\n\n  .login-col2 {\n    grid-column: 1 / 2;\n  }\n\n  .login-form-container {\n    padding-top: 3rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .login-form-inner {\n    width: 100%;\n  }\n\n  .login-form-inner input {\n    width: 100% !important;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
